/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Commission_Empty_Customers_BodyInputs */



/**
* | output |
* | --- |
* | "Customers who sign up through your referral codes will appear here." |
*
* @param {Partner_Commission_Empty_Customers_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_commission_empty_customers_body = /** @type {((inputs?: Partner_Commission_Empty_Customers_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Commission_Empty_Customers_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kunden, die sich über deine Empfehlungscodes registrieren, erscheinen hier.")
	return /** @type {LocalizedString} */ ("Customers who sign up through your referral codes will appear here.")
});